<template>
  <div class="arrange">
    <el-row>
      <el-col :span="6"><h2>排产计划列表</h2></el-col>
      <el-col :span="18">
        <div style="margin-top: 15px;">
          <el-input placeholder="零件型号查询" v-model="inputModel">
            <el-button slot="append" icon="el-icon-search" @click="getModel"></el-button>
          </el-input>
        </div>
      </el-col>
    </el-row>
    <el-table
      :data="tableData"
      style="width: 100%;"
      height="300">
      <el-table-column
        prop="start"
        label="开始日期">
      </el-table-column>
      <el-table-column
        prop="end"
        label="结束日期">
      </el-table-column>
      <el-table-column
        prop="line"
        label="生产线">
      </el-table-column>
      <el-table-column
        prop="numbers"
        label="制令单号">
      </el-table-column>
      <el-table-column
        prop="model"
        label="零件名称">
      </el-table-column>
      <el-table-column
        prop="output"
        label="计划产量">
      </el-table-column>
      <el-table-column
        prop="status"
        label="状态">
      </el-table-column>
      <el-table-column
         fixed="right"
         label="操作"
         width="160">
        <template slot-scope="scope">
          <el-button @click="delRemovePlan(scope.row)" type="warning" size="mini">移除</el-button>
          <el-button @click="delClick(scope.row)" type="danger" size="mini">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24"><h2>添加排产计划</h2></el-col>
    </el-row>
    <el-row :gutter="0">
      <el-form
        ref="addUser"
        :model="formData"
        :rules="rules"
        size="medium"
        label-width="100px"
      >
        <el-col :span="24">
          <el-form-item label="制令单号" prop="numbers">
            <el-input
              v-model="formData.numbers"
              placeholder="请输入制令单号(不能为空）"
              clearable
              :style="{ width: '100%' }"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="零件型号" prop="model">
            <el-select
              v-model="formData.model"
              placeholder="请选择下拉选择零件型号"
              clearable
              :style="{ width: '100%' }"
            >
              <el-option
                v-for="(item, index) in modelOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="计划数量" prop="output">
            <el-input-number
              v-model="formData.output"
              placeholder="计划数量"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生产线" prop="line">
            <el-checkbox-group v-model="formData.line" size="medium">
              <el-checkbox
                v-for="(item, index) in lineOptions"
                :key="index"
                :label="item.value"
                :disabled="item.disabled"
                >{{ item.label }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="计划时间" prop="plannedTime ">
            <el-date-picker
              type="daterange"
              v-model="formData.plannedTime"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :style="{ width: '100%' }"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              range-separator="至"
              clearable
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="计划状态" prop="status">
            <el-select
              v-model="formData.status"
              placeholder="请选择下拉选择"
              clearable
              :style="{ width: '100%' }"
            >
              <el-option
                v-for="(item, index) in statusOptions"
                :key="index"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <div class="bnt clearfix">
          <el-button
            class="enter fr"
            type="primary"
            @click="AddPlan('addUser')"
            round
            >添加</el-button
          >
        </div>
      </el-form>
    </el-row>
  </div>
</template>
<script>
export default {
  components: {},
  props: [],
  data() {
    return {
      inputModel: '', // 零件型号
      formData: {
        numbers: undefined,
        model: undefined,
        output: undefined,
        line: [],
        plannedTime: [],
        status: undefined,
      },
      rules: {
        numbers: [
          {
            required: true,
            message: "请输入制令单号(不能为空）",
            trigger: "blur",
          },
        ],
        model: [
          {
            required: true,
            message: "请选择下拉选择零件型号",
            trigger: "change",
          },
        ],
        output: [
          {
            required: true,
            message: "计划数量",
            trigger: "blur",
          },
        ],
        line: [
          {
            required: true,
            type: "array",
            message: "请至少选择一个line",
            trigger: "change",
          },
        ],
        plannedTime: [
          {
            required: true,
            type: "array",
            message: "请至少选择一个plannedTime ",
            trigger: "change",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择下拉选择",
            trigger: "change",
          },
        ],
      },
      modelOptions: [
        {
          label: "F06锅体",
          value: 1,
        },
        {
          label: "F08锅体",
          value: 2,
        },
        {
          label: "D02锅体",
          value: 3,
        },
        {
          label: "D02加高锅体",
          value: 4,
        },
        {
          label: "D04锅体",
          value: 5,
        },
        {
          label: "D03锅体",
          value: 6,
        },
        {
          label: "AFX001锅体",
          value: 7,
        },
        {
          label: "EA2501锅体",
          value: 8,
        },
        {
          label: "EA4001锅体",
          value: 9,
        },
      ],
      lineOptions: [
        {
          label: "A线",
          value: 1,
        },
        {
          label: "B线",
          value: 2,
        },
      ],
      statusOptions: [
        {
          label: "未完成",
          value: 1,
        },
        {
          label: "计划未实施",
          value: 2,
        },
        {
          label: "计划实施中",
          value: 4,
        },
        {
          label: "已完成",
          value: 5,
        },
      ],
      tableData: [],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getModel();
  },
  mounted() {},
  methods: {
    //------------------request----------start

    // 获取模型
    getModel(){
      this.axios.get("/plan",{params: {model: this.inputModel}}).then((res) => {
        if(res.data.meta.status === 200)
        return this.tableData = res.data.list;
        return this.$message.warning("查询异常！！！");
      });
    },
    // 添加计划
    postPlan(data){
      this.axios.post("/plan",data).then((res) => {
        if (res.data.meta.status === 200) {
          this.$message.success(res.data.meta.msg);
          this.getModel();
        } else if (res.data === 401) {
          return this.$message.warning("添加失败！！！");
        }else{
          return this.$message.warning("操作失败！！！");
        }
      }).catch((err) => {
        return this.$message.error("请求异常！！！");
      });
    },
    // 软删
    delRemovePlan(row){
      this.axios.delete("/plan",{params: {id: row.id}}).then((res)=>{
        if(res.data.meta.status === 200){
          this.$message.success("移除成功！！！");
          this.getModel();
        }else{
          this.$message.warning("操作无效！！！");
        }
      }).catch((err) => {
        this.$message.error("请求异常！！！");
      });
    },
    // 确定强制删除
    delPlan(row){
      this.axios.delete("/delplan",{params: {id: row.id}}).then((res)=>{
        if(res.data.meta.status === 200){
          this.$message.success('删除成功！！！');
          this.getModel();
        }else{
          this.$message.warning("操作无效！！！");
        }
      }).catch((err) => {
        this.$message.error("请求异常！！！");
      });
    },


    //------------------request----------end

    // 添加计划（获取数据）
    AddPlan(formName) {
      this.$refs[formName].validate((valid) => {
        let data = {
          numbers: this.formData.numbers,
          model: this.modelOptions[this.formData.model - 1].label,
          output: this.formData.output,
          line: this.lineOptions[this.formData.line[0] - 1].label,
          status:  this.statusOptions[this.formData.status-1].label,
          start: this.formData.plannedTime[0],
          end: this.formData.plannedTime[1],
        };
        if (valid) {
          this.postPlan(data);
        }else{
          return this.$message.warning("数据格式不对！！！");
        }
      });
    },
    // 强制删除（提示）
    delClick(row){
      this.$alert('该操作将无法恢复数据，是否确定删除？', '确认操作', {
          confirmButtonText: '确定',
          callback: action => {
            if(action === 'confirm'){
              this.delPlan(row);
            }
          }
      });
    },

  },
};
</script>
<style lang="less" scoped>
.arrange {
  width: 100%;
  margin: 30px auto;
  .arrange-text {
    text-align: center;
  }
  .bnt {
    width: 100%;
    .enter {
      width: 100%;
      margin: 30px auto 20px;
      display: block;
    }
  }
}
</style>
